module.exports = __webpack_public_path__ + "img/footer-logo.bcb312ae.png";